<template>
  <div class="index-modular">
    <div class="header-modular">
      <div class="bannber-modular">
        <div class="bannber-menu-tar">
          <!-- 商品列表 -->
          <!-- <div class="tree-level-modular">
            <div
              class="menu-tar-item"
              v-for="(item, index) in bannerTarList"
              :key="index"
              @click="searchProductByType(index, item.id)"
              v-if="item.id != 0"
            >
              {{ currLanguage == 3 ? item.eng_name : item.name }}
            </div>
          </div> -->
          <!-- <div class="tree-level-modular">
            <div class="tree-level-1" v-for="(item, index) in bannerTarList" :key="index">
              <div v-if="item.level1.id == 0"
                :class="(activeProductTypeId == item.level1.id ? 'category-tree-all text-red' : 'category-tree-all')">{{
                  (currLanguage == 3 ? item.level1.eng_name : item.level1.name) }}</div>
              <div v-else>
                <div @click="openNextLevel(index, item.level1.id)">
                  <span
                    :class="(activeProductTypeId == item.level1.id ? 'category-tree-all text-red' : 'category-tree-all')">{{
                      (currLanguage == 3 ? item.level1.eng_name : item.level1.name) }}</span>
                  <img class="tree-icon" v-if="item.level1.flag" src="../assets/product/tree-close-icon.png" alt="">
                  <img class="tree-icon" v-else src="../assets/product/tree-open-icon.png" alt="">
                </div>

                <div class="tree-level-2" v-if="item.level1.flag" v-for="(item2, index2) in item.level1.children"
                  :key="index2">
                  <div @click="searchProductByType(index, item.level1.id, item2.id)">{{ (currLanguage == 3 ?
                    item2.eng_name
                    :
                    item2.name)
                  }}</div>
                </div>
              </div>
            </div>
          </div> -->
        </div>
        <div class="banner-bg-modular">
          <el-carousel rigger="click" :autoplay="false">
            <el-carousel-item v-for="item in bigBannerImgList" :key="item.id">
              <img class="banner-img" :src="item.url" alt=""   @click="tourl(item.jump_url)" style="cursor: pointer"/>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <div class="show-buy-modular">
      <div class="show-buy-item show-buy-item1" v-for="item in smallBannerImgList" :key="item.id">
        <img class="show-buy-item-img" :src="item.url" alt="" @click="toCoupon(item.temp_id)" />
      </div>
      <!-- <div class="show-buy-item show-buy-item1">
        <img
          src="../assets/home/banner-tar-2.png"
          alt=""
          class="show-buy-item-img"
        />
      </div>
      <div class="show-buy-item show-buy-item1">
        <img
          src="../assets/home/banner-tar-3.png"
          alt=""
          class="show-buy-item-img"
        />
      </div> -->
    </div>
    <!-- <div class="show-buy-modular">
      <el-row :gutter="10">
        <el-col :span="8" :xs="24">
          <div class="show-buy-item show-buy-item1" @click="toCoupon()">
            <img
              class="show-buy-item-img"
              src="../assets/home/banner-tar-1.png"
              alt=""
            />
            <div class="show-buy-item-msg">
              <p class="show-buy-item-title">
                <span class="show-buy-item-title-text1">{{
                  pageText.couponText")
                }}</span>
                <span class="show-buy-item-title-text2">{{
                  pageText.subtractmoneyText")
                }}</span>
              </p>
              <p class="show-buy-item-line">
                <span class="buy-item-line-left"></span>
                <span class="buy-item-line-title">{{
                  pageText.magnanimitycouponText")
                }}</span>
                <span class="buy-item-line-right"></span>
              </p>
              <p class="show-buy-item-receive">
                <button class="receive-btn">
                  <span>{{ pageText.drawText") }}</span>
                  <img src="../assets/home/banner-tar-arrow-icon.png" alt="" />
                </button>
              </p>
            </div>
          </div>
        </el-col>
        <el-col :span="8" :xs="24">
          <div
            class="show-buy-item show-buy-item2"
            @click="toCommodityDiscount()"
          >
            <img
              class="show-buy-item-img"
              src="../assets/home/banner-tar-2.png"
              alt=""
            />
            <div class="show-buy-item-msg">
              <p class="show-buy-item-title1">
                {{ pageText.discountText") }}
              </p>
              <p class="show-buy-item-title2">
                <span class="show-buy-item-title-text1">UP TO</span>
                <span class="show-buy-item-title-text2">25% OFF</span>
              </p>
              <p class="show-buy-item-receive">
                <button class="receive-btn">
                  <span>{{ pageText.purchaseText") }}</span>
                  <img src="../assets/home/banner-tar-arrow-icon.png" alt="" />
                </button>
              </p>
            </div>
          </div>
        </el-col>
        <el-col :span="8" :xs="24">
          <div
            class="show-buy-item show-buy-item3"
            @click="toCommodityPortfolio()"
          >
            <img
              class="show-buy-item-img"
              src="../assets/home/banner-tar-3.png"
              alt=""
            />
            <div class="show-buy-item-msg">
              <p class="show-buy-item-title1">
                {{ pageText.composecouponText") }}
              </p>
              <p class="show-buy-item-title2">
                {{ pageText.manyDiscountsText") }}
              </p>
              <p class="show-buy-item-receive">
                <button class="receive-btn">
                  <span>{{ pageText.purchaseText") }}</span>
                  <img src="../assets/home/banner-tar-arrow-icon.png" alt="" />
                </button>
              </p>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>  -->
    <div class="body-modular">
      <div class="commodity-recommend-modular">
        <div class="recommend-title-modular">
          <img class="recommend-img" src="../assets/home/recommend-title-left-icon.png" alt="" />
          <span class="recommend-text">
            {{
              currLanguage == 3
              ? recommendProductText.eng_name
              : pageTextArr[4]
            }}</span>
          <img class="recommend-img" src="../assets/home/recommend-title-right-icon.png" alt="" />
        </div>
        <div class="commodity-show-modular" v-loading="recommendProductLoad">
          <div v-if="recommendProductData.length == 0" class="my-evaluate-bodu-none">
            <img class="none-icon" src="../assets/public/none-icon.png" alt="" />
            <p class="none-title">{{ pageTextArr[0] }}</p>
          </div>
          <div v-else class="commodity-show-item-modualr" v-for="(item, index) in recommendProductData" :key="index">
            <div class="commodity-show-item" v-if="index < 5">
              <div class="commodity-show-item-img" @click="toProductDetail(item.id)">
                <img class="commodity-show-img" :src="item.cover" alt="" />
              </div>
              <div class="commodity-show-item-msg">
                <div class="commodity-show-item-price">
                  {{ currencySymbol
                  }}{{
  item.has_discount == 1 ? item.discount_price : item.price
}}
                  <span class="commodity-show-item-discpunt-price" v-if="item.has_discount == 1">
                    {{ currencySymbol }}{{ item.price }}
                  </span>
                </div>
                <div class="commodity-show-item-introduce">
                  {{ currLanguage == 3 ? item.eng_title : item.title }}
                </div>
                <div class="commodity-show-item-evaluate">
                  <div class="commodity-evaluate">
                    <!-- <span class="commodity-evaluate-num">{{
                      item.comment_num
                    }}</span>
                    <span class="commodity-evaluate-title">{{
                      pageText.appraiseText")
                    }}</span> -->
                  </div>
                  <div class="commodity-coupon" v-if="item.has_coupon == 1">
                    <!-- {{ pageText.certificate }} -->
                    {{ pageTextArr[1] }}
                  </div>
                </div>
                <div class="commodity-show-item-operation">
                  <div class="commodity-shop-cart" @click="toProductDetail(item.id)">
                    <span class="add-cart-title">
                      <!-- {{ pageText.productDetailsText }} -->
                      {{ pageTextArr[3] }}
                    </span>
                  </div>
                </div>
                <div class="commodity-show-item-operation">
                  <!-- <div
                    class="commodity-collection"
                    @click="
                      productaddCollect(item.id, item.is_collect, index, 1)
                    "
                  >
                    <img
                      class="collection-icon"
                      v-if="item.is_collect == 1"
                      src="../assets/home/collection-icon-2.png"
                      alt=""
                    />
                    <img
                      class="collection-icon"
                      v-else
                      src="../assets/home/collection-icon.png"
                      alt=""
                    />
                    <span class="collection-title">{{
                      pageText.collectText
                    }}</span>
                  </div> -->
                  <div class="commodity-shop-cart shop-cart-color" @click="productAddCart(item.id, item.number, 1, '', 1)">
                    <!-- <img
                      class="shop-cart-icon"
                      src="../assets/home/shop-cart-icon.png"
                      alt=""
                    /> -->
                    <span class="add-cart-title">
                      {{ pageTextArr[2] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="commodity-recommend-modular">
        <div class="recommend-title-modular">
          <img class="recommend-img" src="../assets/home/recommend-title-left-icon.png" alt="" />
          <span class="recommend-text">{{
            currLanguage == 3
            ? hotSaleProductText.eng_name
            : pageTextArr[5]
          }}</span>
          <img class="recommend-img" src="../assets/home/recommend-title-right-icon.png" alt="" />
        </div>
        <!-- <div class="commodity-tar-modular">
          <div
            :class="
              item.id == currproductTyprId
                ? 'commodity-tar-item tar-item-active'
                : 'commodity-tar-item'
            "
            v-for="(item, index) in commodityTarList"
            :key="index"
            @click="getProductSignListById(item.id)"
          >
            <el-tooltip
              class="item"
              effect="dark"
              :content="currLanguage == 3 ? item.eng_name : item.name"
              placement="top-start"
            >
              <span class="commodity-tar-item-title">{{
                currLanguage == 3 ? item.eng_name : item.name
              }}</span>
            </el-tooltip>
          </div>
        </div> -->
        <div class="commodity-show-modular commodity-ho-sale" v-loading="hotSaleProductLoad">
          <div v-if="hotSaleProductData.length == 0" class="my-evaluate-bodu-none">
            <img class="none-icon" src="../assets/public/none-icon.png" alt="" />
            <p class="none-title">{{ pageTextArr[0] }}</p>
          </div>
          <div v-else class="commodity-show-item-modualr" v-for="(item, index) in hotSaleProductData" :key="index">
            <div class="commodity-show-item" v-if="index < 5">
              <div class="commodity-show-item-img" @click="toProductDetail(item.id)">
                <img class="commodity-show-img" :src="item.cover" alt="" />
              </div>
              <div class="commodity-show-item-msg">
                <div class="commodity-show-item-price">
                  {{ currencySymbol
                  }}{{
  item.has_discount == 1 ? item.discount_price : item.price
}}
                  <span class="commodity-show-item-discpunt-price" v-if="item.has_discount == 1">
                    {{ currencySymbol }}{{ item.price }}
                  </span>
                </div>
                <div class="commodity-show-item-introduce">
                  {{ currLanguage == 3 ? item.eng_title : item.title }}
                </div>
                <div class="commodity-show-item-evaluate">
                  <div class="commodity-evaluate">
                    <!-- <span class="commodity-evaluate-num">{{
                      item.comment_num
                    }}</span>
                    <span class="commodity-evaluate-title">{{
                      pageText.appraiseText
                    }}</span> -->
                  </div>
                  <div class="commodity-coupon" v-if="item.has_coupon == 1">
                    <!-- {{ pageText.certificate }} -->
                    {{ pageTextArr[1] }}
                  </div>
                </div>
                <div class="commodity-show-item-operation">
                  <div class="commodity-shop-cart" @click="toProductDetail(item.id)">
                    <span class="add-cart-title">
                      <!-- {{ pageText.productDetailsText }} -->
                      {{ pageTextArr[3] }}
                    </span>
                  </div>
                </div>
                <div class="commodity-show-item-operation">
                  <!-- <div
                    class="commodity-collection"
                    @click="
                      productaddCollect(item.id, item.is_collect, index, 2)
                    "
                  >
                    <img
                      class="collection-icon"
                      v-if="item.is_collect == 1"
                      src="../assets/home/collection-icon-2.png"
                      alt=""
                    />
                    <img
                      class="collection-icon"
                      v-else
                      src="../assets/home/collection-icon.png"
                      alt=""
                    />
                    <span class="collection-title">{{
                      pageText.collectText
                    }}</span>
                  </div> -->
                  <div class="commodity-shop-cart shop-cart-color" @click="productAddCart(item.id, item.number, 1, '', 1)">
                    <!-- <img
                      class="shop-cart-icon"
                      src="../assets/home/shop-cart-icon.png"
                      alt=""
                    /> -->
                    <span class="add-cart-title">
                      <!-- {{ pageText.addCartText }} -->
                      {{ pageTextArr[2] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="commodity-recommend-modular">
        <div class="recommend-title-modular">
          <img class="recommend-img" src="../assets/home/recommend-title-left-icon.png" alt="" />
          <span class="recommend-text">{{
            currLanguage == 3
            ? guessLikeProductText.eng_name
            : pageTextArr[6]
          }}</span>
          <img class="recommend-img" src="../assets/home/recommend-title-right-icon.png" alt="" />
        </div>
        <div class="commodity-show-modular" v-loading="guessLikeProductLoad">
          <div v-if="guessLikeProductData.length == 0" class="my-evaluate-bodu-none">
            <img class="none-icon" src="../assets/public/none-icon.png" alt="" />
            <p class="none-title">{{ pageTextArr[0] }}</p>
          </div>
          <div v-else class="commodity-show-item-modualr" v-for="(item, index) in guessLikeProductData" :key="index">
            <div class="commodity-show-item" v-if="index < 5">
              <div class="commodity-show-item-img" @click="toProductDetail(item.id)">
                <img class="commodity-show-img" :src="item.cover" alt="" />
              </div>
              <div class="commodity-show-item-msg">
                <div class="commodity-show-item-price">
                  {{ currencySymbol
                  }}{{
  item.has_discount == 1 ? item.discount_price : item.price
}}
                  <span class="commodity-show-item-discpunt-price" v-if="item.has_discount == 1">
                    {{ currencySymbol }}{{ item.price }}
                  </span>
                </div>
                <div class="commodity-show-item-introduce">
                  {{ currLanguage == 3 ? item.eng_title : item.title }}
                </div>
                <div class="commodity-show-item-evaluate">
                  <div class="commodity-evaluate">
                    <!-- <span class="commodity-evaluate-num">{{
                      item.comment_num
                    }}</span>
                    <span class="commodity-evaluate-title">{{
                      pageText.appraiseText
                    }}</span> -->
                  </div>
                  <div class="commodity-coupon" v-if="item.has_coupon == 1">
                    <!-- {{ pageText.certificate }} -->
                    {{ pageTextArr[1] }}
                  </div>
                </div>
                <div class="commodity-show-item-operation">
                  <div class="commodity-shop-cart" @click="toProductDetail(item.id)">
                    <span class="add-cart-title">
                      <!-- {{ pageText.productDetailsText }} -->
                      {{ pageTextArr[3] }}
                    </span>
                  </div>
                </div>
                <div class="commodity-show-item-operation">
                  <!-- <div
                    class="commodity-collection"
                    @click="
                      productaddCollect(item.id, item.is_collect, index, 3)
                    "
                  >
                    <img
                      class="collection-icon"
                      v-if="item.is_collect == 1"
                      src="../assets/home/collection-icon-2.png"
                      alt=""
                    />
                    <img
                      class="collection-icon"
                      v-else
                      src="../assets/home/collection-icon.png"
                      alt=""
                    />
                    <span class="collection-title">{{
                      pageText.collectText
                    }}</span>
                  </div> -->
                  <div class="commodity-shop-cart shop-cart-color" @click="productAddCart(item.id, item.number, 1, '', 1)">
                    <!-- <img
                      class="shop-cart-icon"
                      src="../assets/home/shop-cart-icon.png"
                      alt=""
                    /> -->
                    <span class="add-cart-title">
                      <!-- {{ pageText.addCartText }} -->
                      {{ pageTextArr[2] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      page: 1,
      pagesize: 5,
      currencySymbol:
        localStorage.getItem("currencySymbol") == null
          ? "$"
          : localStorage.getItem("currencySymbol"),
      currLanguage: localStorage.getItem("curLanguageType"), //当前语言
      pageCount: 1, //分页总数
      recommendProductText: {},
      hotSaleProductText: {},
      guessLikeProductText: {},
      // 推荐产品
      recommendProductData: [],
      recommendProductLoad: false,
      // 热销产品
      hotSaleProductData: [],
      hotSaleProductLoad: false,
      // 猜你喜欢-产品
      guessLikeProductData: [],
      guessLikeProductLoad: false,
      activeProductTypeId: 0, //商品分类-active
      // 商品列表
      bannerTarList: [],
      currproductTyprId: 0,
      commodityTarList: [
        // {
        //   index: 0,
        //   title: '全部'
        // },
        // {
        //   index: 1,
        //   title: '回流焊'
        // },
        // {
        //   index: 2,
        //   title: '贴片机'
        // },
        // {
        //   index: 3,
        //   title: '拆焊台'
        // },
        // {
        //   index: 4,
        //   title: '雕刻机'
        // },
        // {
        //   index: 5,
        //   title: '其他'
        // },
      ],
      pageText: {
        recommendtitleText: "",//为你推荐
        hotsaleproductyitleText: "",//热销产品
        guessLiketitleText: "",//猜你喜欢
        NoDataText: "暂无数据",
        certificate: "券",
        addCartText: "加入购物车",
        productDetailsText: "产品细节",
      },
      pageTextArr: [
        "暂无数据",
        "优惠券",
        "加入购物车",
        "产品细节",
        "为你推荐",
        "热销产品",
        "猜你喜欢",
      ],
      bigBannerImgList: [],
      smallBannerImgList: [],
    };
  },
  created() {
    // document
    //   .querySelector('meta[name="Keywords key3"]')
    //   .setAttribute('content', '12333')
  },
  methods: {
    /**
     * banner图跳转
     */
    tourl(jumpurl){
      window.location.href=jumpurl;
    },
    /**
     * 跳转优惠劵
     */
    toCoupon(temp_id) {
      // this.$router.push({
      //   path: "/commodityCoupon",
      //   query: { name: "", age: "" },
      // });
      if (temp_id == 1) {
        // 组合商品
        this.$router.push({
          path: "/commodityPortfolio",
          query: {
            name: this.currLanguage == 3 ? "Combination products" : "组合商品",
          },
        });
      } else if (temp_id == 2) {
        // 折扣商品
        this.$router.push({
          path: "/commodityDiscount",
          query: {
            name: this.currLanguage == 3 ? "Discount products" : "折扣商品",
          },
        });
      } else if (temp_id == 3) {
        // 优惠券商品
        this.$router.push({
          path: "/commodityCoupon",
          query: {
            name: this.currLanguage == 3 ? "Coupon product" : "优惠券商品",
          },
        });
      }
    },
    /**
     * 获取banner列表
     */
    getBannerList(type) {
      let that = this;
      let data = {
        page: 1,
        pagesize: 3,
        type_id: type,
      };
      this.$http.getBannerList(data, (res) => {
        // console.log(res);
        if (res.ret == 1) {
          if (type == 1) {
            that.bigBannerImgList = res.data;
          } else {
            that.smallBannerImgList = res.data;
          }
        }
      });
    },

    /**
     * 跳转商品
     * @param {*} id
     */
    toProduct(id) {
      this.$router.push({
        path: "/productShow",
        query: { id: id },
      });
    },

    /**
     * 跳转商品详情
     * @param {*} id
     */
    toProductDetail(id) {
      this.$router.push({
        path: "/productDetail",
        query: { product_id: id },
      });
    },

    /**
     * 跳转组合购买
     */
    toCommodityPortfolio() {
      this.$router.push({
        path: "/commodityPortfolio",
        query: { name: "", age: "" },
      });
    },

    /**
     * 跳转折扣
     */
    toCommodityDiscount() {
      this.$router.push({
        path: "/commodityDiscount",
        query: { name: "", age: "" },
      });
    },

    /**
     * 商品分类
     */
    getCategoryList() {
      let that = this;
      let data = {
        page: 1,
        pagesize: 1000,
      };
      that.bannerTarList = []; //清空
      this.$http.getCategoryList(
        data,
        (res) => {
          if (res.ret == 1) {
            that.commodityTarList = res.data;
            that.bannerTarList = res.data;
            // api数据翻译
            // that.translateApiData(res.data, "name", -1);
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 产品类别点击
     * @param {*} index
     * @param {*} id
     */
    openNextLevel(index, id) {
      let that = this;
      let netData = that.bannerTarList[index];
      netData.level1.flag = !netData.level1.flag;
      that.$set(that.bannerTarList, index, netData);
      // 选中的产品-id
      that.activeProductTypeId = id;
    },

    /**
     * 根据类型获取商品
     * @param {*} index
     * @param {*} id
     */
    searchProductByType(index, levId) {
      let that = this;
      this.$parent.$refs.headerMenuModular.activeIndex = 1;
      localStorage.setItem("menuActiveIndex", 1);
      // 产品类型ID
      this.$router.push({
        path: "/productShow",
        query: {
          currProductTypeId: levId,
          index: index,
          levId: levId,
          pageStaus: 1,
        },
      });
      this.$parent.$parent.reload();
    },

    /**
     * 热销产品-列表点击
     * @param {*} typeId
     */
    getProductSignListById(typeId) {
      let that = this;
      that.currproductTyprId = typeId;
      // 热销产品
      that.getProductSignList(2);
    },

    /**
     *  商品列表
     * @param {*} id
     */
    getProductSignList(id) {
      let that = this;
      let data = {
        id: id,
        type_id: that.currproductTyprId,
        page: that.page,
        pagesize: that.pagesize,
        exchange_rate: localStorage.getItem("currencyRate"), //汇率值
      };
      this.$http.getProductSignList(
        data,
        (res) => {
          if (res.ret == 1) {
            //  商品数据赋值
            that.setProductById(id, res);
          } else {
            // this.$message.error(res.msg);
            // 清空 - 热销产品
            that.hotSaleProductData = [];
            that.recommendProductLoad = false;
            that.hotSaleProductLoad = false;
            that.guessLikeProductLoad = false;
          }
        },
        (res) => {
          that.recommendProductLoad = false;
          that.hotSaleProductLoad = false;
          that.guessLikeProductLoad = false;
          // 清空 - 热销产品
          that.hotSaleProductData = [];
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 商品数据赋值
     * @param {*} id
     * @param {*} res
     */
    setProductById(id, res) {
      let that = this;
      switch (parseInt(id)) {
        // 1为你推荐
        case 1:
          // loading
          that.recommendProductLoad = false;
          that.recommendProductData = res.data;
          that.recommendProductText = {
            name: res.name,
            eng_name: res.eng_name,
          };
          // that.pageText.recommendtitleText = res.name
          // api数据翻译
          that.translateApiData(res.data, "title", 1);
          break;
        // 2热销产品
        case 2:
          // loading
          that.hotSaleProductLoad = false;
          that.hotSaleProductData = res.data;
          that.hotSaleProductText = {
            name: res.name,
            eng_name: res.eng_name,
          };
          // that.pageText.hotsaleproductyitleText = res.name
          // api数据翻译
          that.translateApiData(res.data, "title", 2);
          break;
        //3猜你喜欢
        case 3:
          // loading
          that.guessLikeProductLoad = false;
          that.guessLikeProductData = res.data;
          that.guessLikeProductText = {
            name: res.name,
            eng_name: res.eng_name,
          };
          // that.pageText.guessLiketitleText = res.name
          // api数据翻译
          that.translateApiData(res.data, "title", 3);
          break;

        default:
          that.recommendProductData = data;
          that.recommendProductText = {
            name: res.name,
            eng_name: res.eng_name,
          };
          // that.pageText.recommendtitleText = res.name

          // api数据翻译
          that.translateApiData(data, "title", 1);
          break;
      }

      // that.pageTranslate();
      // console.log(" that.recommendProductData ", that.recommendProductData);
    },

    /**
     * 商品加入购物车
     * @param {*} product_id
     * @param {*} sku_number
     * @param {*} type
     * @param {*} portfolio_sales_middle_id
     * @param {*} cartNum
     */
    productAddCart(
      product_id,
      sku_number,
      type,
      portfolio_sales_middle_id,
      cartNum
    ) {
      let that = this;
      // if (this.$parent.tipsLogin()) return;
      that.$parent.addCart(
        product_id,
        sku_number,
        type,
        portfolio_sales_middle_id,
        cartNum
      );
    },

    /**
     *  加入收藏 取消收藏
     * @param {*} id
     * @param {*} status
     * @param {*} index
     * @param {*} flag
     */
    productaddCollect(id, status, index, flag) {
      let that = this;
      that.$parent.productCollect(
        id,
        status,
        (res) => {
          if (res.ret == 1) {
            this.$message.success(res.msg);
            // 设置当前list表的收藏状态
            that.setProductCollectById(status, index, flag);
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          this.$message.error(res.msg);
        }
      );
    },
    /**
     * 设置当前list表的收藏状态
     * @param {*} status
     * @param {*} index
     * @param {*} flag  1-推荐 2-热销 3-猜你喜欢
     */
    setProductCollectById(status, index, flag) {
      let that = this;
      let newData;
      switch (flag) {
        case 1:
          // 推荐
          newData = that.recommendProductData[index];
          newData.is_collect = !status;
          this.$set(that.recommendProductData, index, newData);
          break;
        case 2:
          // 热销
          newData = that.hotSaleProductData[index];
          newData.is_collect = !status;
          this.$set(that.recommendProductData, index, newData);
          break;
        case 3:
          // 惨你喜欢
          newData = that.guessLikeProductData[index];
          newData.is_collect = !status;
          this.$set(that.recommendProductData, index, newData);
          break;

        default:
          break;
      }
    },

    /**
     * 语言翻译 - 单个词语
     * @param {*} text
     */
    // languageTranslate(text) {
    //   let that = this;
    //   this.$parent.translate(
    //     text,
    //     (res) => {
    //       // 处理页面死数据
    //       that.processingResults(res.data);
    //     },
    //     (res) => {}
    //   );
    // },

    /**
     * 翻译
     */
    pageTranslate() {
      let that = this;
      let transformText = "";
      for (const key in that.pageText) {
        transformText += key + "=" + that.pageText[key] + "&";
      }

      that.languageTranslate(transformText);
    },

    /**
     * 处理返回的结果
     */
    processingResults(data) {
      let that = this;
      let textArr = data.split("&amp;");

      textArr.forEach((v, i) => {
        if (v != "") {
          for (const key in that.pageText) {
            if (v.split("=")[0] == key) {
              that.pageText[key] = v.split("=")[1];
            }
          }
        }
      });
    },
    /**
     * 处理APIde数据进行翻译
     * @param {*} data
     */
    translateApiData(data, title, type) {
      let that = this;
      let newTextArr = [];

      data.forEach((v, i) => {
        for (const key in v) {
          if (key == title) {
            newTextArr.push(v[key]);
          }
        }
      });
      that.languageTranslateByArr(newTextArr, title, type);
    },

    /**
     * 语言翻译 - 数组
     * @param {*} arr
     */
    languageTranslateByArr(arr, title, type) {
      let that = this;
      this.$parent.translateByArr(
        arr,
        (res) => {
          // 翻译api类型
          that.processingResultsByArr(res.data, title, type);
        },
        (res) => { }
      );
    },
    /**
     * api 处理返回的翻译数据
     * @param {*} data
     */
    processingResultsByArr(data, title, type) {
      let that = this;
      data.forEach((v, i) => {
        switch (type) {
          case -1:
            that.commodityTarList[i][title] = v.translation;
            that.bannerTarList[i][title] = v.translation;
            break;
          case 1:
            console.log(that.recommendProductData);
            that.recommendProductData[i][title] = v.translation;
            break;
          case 2:
            console.log(that.hotSaleProductData);
            that.hotSaleProductData[i][title] = v.translation;
            break;
          case 3:
            console.log(that.guessLikeProductData);
            that.guessLikeProductData[i][title] = v.translation;
            break;
          default:
            break;
        }
      });
    },
    translateByArr(arr, callback, errCallBack) {
      let that = this;
      let data = {
        text: arr, //带翻译数组
        from: localStorage.getItem("oldLanguageCode"), //源语言
        to: localStorage.getItem("curLanguageCode"), //目标语言
      };
      if (data.from == data.to) {
        return;
      }
      this.$http.translateByArr(data, callback, errCallBack);
    },

    languageTranslateByArrs(arr) {
      let that = this
      let newpagetextArr = []
      that.translateByArr(arr, res => {
        console.log("res", res);
        res.data.forEach((item, index) => {
          newpagetextArr.push(item.translation)
        })
        that.pageTextArr = newpagetextArr
      })
    }
  },
  mounted() {
    let that = this;
    let url = window.location.href
    console.log("url",url)
    localStorage.setItem("url",url)
    // 当前语言
    that.currLanguage = localStorage.getItem("curLanguageType");
    // 商品分类
    // that.getCategoryList();
    //为你推荐
    that.getProductSignList(1);
    //热销产品
    that.getProductSignList(2);
    //猜你喜欢
    that.getProductSignList(3);
    // 翻译
    that.getBannerList(1);
    that.getBannerList(2);
    that.languageTranslateByArrs(that.pageTextArr);
    // loading - 加载
    that.recommendProductLoad = true;
    that.hotSaleProductLoad = true;
    that.guessLikeProductLoad = true;
  },
};
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/view/home.vue